export interface ConfigureSchemaValidationOperationResult {
    raftCommandIndex?: number;
}
